import { NextSeo, BreadcrumbJsonLd, ArticleJsonLd } from "next-seo";
import { Topic } from "shared/types";
import { getFormatTopicDate } from "../utils/getFormatTopicDate";
import { useTopicImage } from "../hooks/useTopicImage";
import { useTopicMetaData } from "../hooks/useTopicMetaData";

interface Props {
  topic: Topic;
}

const TopicDetailSeo = ({ topic }: Props) => {
  const { url, siteName } = useTopicMetaData(topic);
  const { largeImage } = useTopicImage(topic);
  const { publishedAtISO, lastmodISO } = getFormatTopicDate(topic);

  return (
    <>
      <NextSeo
        title={topic.title}
        description={topic.meta}
        canonical={url}
        additionalLinkTags={[{ rel: "icon", href: "/favicon.ico" }]}
        openGraph={{
          url,
          type: "article",
          title: topic.title,
          description: topic.meta,
          images: [{ url }],
          site_name: siteName,
          article: {
            publishedTime: publishedAtISO,
            modifiedTime: lastmodISO,
          },
        }}
      />
      <BreadcrumbJsonLd
        itemListElements={[
          {
            position: 1,
            name: "チャット占い・電話占い",
            item: "https://miror.jp/",
          },
          {
            position: 2,
            name: topic.tag ? topic.tag.name : "",
            item: topic.tag ? `https://miror.jp/tag/${topic.tag.id}` : "",
          },
          {
            position: 3,
            name: topic.title,
            item: url,
          },
        ]}
      />
      <ArticleJsonLd
        url={url}
        title={topic.title}
        images={[largeImage]}
        datePublished={publishedAtISO}
        dateModified={lastmodISO}
        authorName={[]}
        publisherName=""
        publisherLogo=""
        description={topic.meta}
      />
    </>
  );
};

export default TopicDetailSeo;
